import React from 'react'
//import {ajaxGet, ajaxPost} from 'api/explus-api'
import WebService from 'api/explus-api'
import Loader from '../Loader/Loader'
import UserEdit from './UserEdit'
import swal from "sweetalert2";

class UserEditContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      user: '',
      phones: '',
      fname: '',
      selectedGender: 'Select',
      loaded: false,
      loading: false
    }
    this.selectGender = this.selectGender.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleFileChange = this.handleFileChange.bind(this)
    this.getDatePickerValue = this.getDatePickerValue.bind(this)
    this.renderImage = this.renderImage.bind(this)

    this.handleChangePhone = this.handleChangePhone.bind(this);
    this.addPhone = this.addPhone.bind(this);
    this.deletePhone = this.deletePhone.bind(this);
  }

  componentDidMount() {
    this.getUser()
  }

  getDatePickerValue(value) {
    this.setState(prevState => ({user: {...prevState.user, birthdate: value}}))
  }

  // fileUpload(file) {
  //   if (!file || file === '') {return this.state.user.avatar_url}
  //   const formData = new FormData();
  //   formData.append('filename',file)

  //   return formData
  // }

  handleSubmit(e) {
    e.preventDefault()
    this.setState({loading: true})
    const user = this.state.user
    const phones = this.state.phones //2022

    // console.log(user)
    // return

    // let postData = {
    //   "birthdate": user.birthdate,
    //   "address1": user.address1,
    //   "address2": user.address2,
    //   "city": user.city,
    //   "state": user.state,
    //   "postal_code": user.postal_code,
    //   "country": user.country,
    //   "given_name": user.given_name,
    //   "family_name": user.family_name,
    //   "gender_code": user.gender_code,
    //   "email_address": user.user_info.email,
    // }

    const formData = new FormData()
    formData.append('photo',this.state.file)
    formData.append('birthdate',user.birthdate)
    formData.append('address1',user.address1)
    formData.append('address2',user.address2)
    formData.append('city',user.city)
    formData.append('state',user.state)
    formData.append('postal_code',user.postal_code)
    formData.append('country',user.country)
    formData.append('given_name',user.given_name)
    formData.append('family_name',user.family_name)
    formData.append('gender_code',user.gender_code)
    formData.append('email_address',user.email)
    if (user.newpassword) {
      formData.append('password',user.password)
      formData.append('newpassword',user.newpassword)
      formData.append('confirmpassword',user.confirmpassword)
    }

    // 2022
    if (phones && phones.length > 0) {
      formData.append('phone', JSON.stringify(phones));
    }
    //console.log([...formData])

  //   for(var pair of formData.entries()) {
  //     console.log(pair[0]+ ', '+ pair[1]); 
  //  }

  //  return

    return WebService.ajaxPost('web/partners', formData).then(data => {
      this.getPhone() //2022
      this.setState({loading: false})
    })
  }

  getUser() {
    return WebService.ajaxGet('web/partners').then(data => {
      if (data.status !== undefined || data.status === 'error') { return alert(data.message) }
      let user = Object.assign({}, data)
      delete user.user_info
      user = {...user, ...data.user_info}

      this.setState({user: user})
      this.getGender(user.gender_code)
      this.getPhone() //2022
    })
  }

  getGender(value) {
    let gender = this.state.user.gender_code

    if(value === 'M') {
      gender = 'Male'
    }

    if(value === 'F') {
      gender = 'Female'
    }

    this.setState({selectedGender: gender})
    this.setState(prevState => ({user: {
      ...prevState.user, gender_code: value
      }
    }))
  }

  // 2022
  getPhone() {
    WebService.ajaxGet('partner/phone').then(data => {
      if (data.status !== undefined || data.status === 'error') { return alert(data.message) }
      this.setState({loaded: true})

      this.setState({phones: data})
    })
  }

  selectGender(value) {
    return event => {
      event.preventDefault()

      this.getGender(value)
    }
  }

  handleChange(e) {
    const target = e.target
    const name = target.name
    const value = target.value

    this.setState(prevState => ({user: {...prevState.user, [name]: value}}))
  }

  //2022
  handleChangePhone(e, index) {
    const target = e.target
    // const id = target.id
    const name = target.name
    const value = target.value
    // const phone = target.dataset.phone;

    const existingPhones = [...this.state.phones];
    existingPhones[index][name] = value;

    this.setState(prevState => (
      {
        phones: existingPhones
      }
    ))
  }

  // 2022
  addPhone(){
    const existingPhones = [...this.state.phones];

    existingPhones.push({
      partner_id: parseInt(this.state.user.partner_id),
      phone_number: "",
    });

    this.setState(prevState => (
      {
        phones: existingPhones
      }
    ))
  }

  // 2022
  deletePhone(index){
    const existingPhones = [...this.state.phones];
    const targetPhone = existingPhones[index];

    if(targetPhone.hasOwnProperty('id')){ // Permanently Delete Phone

      swal.fire({
            title: targetPhone['phone_number'],
            type: 'error',
            html: "Are you sure you want to delete phone number?<br/>This process cannot be undone.",
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Delete',
        }).then((res) => {

          if (res.value) {
            this.setState({loading: true})
            const param = "?id=" + targetPhone.id;

            WebService.ajaxPhone('partner/phone/delete', param).then(data => {
              if (data.status !== undefined || data.status === 'error') { 
                return swal.fire("Error", data.message, "error");
              }

              this.getPhone()
              this.setState({loading: false})

              return swal.fire("Sucess", "Successfully deleted", "success");
            })
          }
          
        });

    }else{//Remove New Entry Item

      existingPhones.splice(index, 1);

      this.setState(prevState => (
        {
          phones: existingPhones
        }
      ))

    }
  }

  renderImage() {
    if (this.state.img) {
      return React.createElement(
        'img', {src: this.state.img}, null
      )
    }
  }

  handleFileChange(event) {
    const target = event.target
    const name = target.name
    const file = target.files[0]
    // const self = this

    // let img = new Image()

    // const reader = new FileReader()

    // reader.readAsDataURL(file)

    this.setState({fname: file['name']})
    this.setState({[name]: file})

    // reader.onload = function(target) {
    //   img.src = reader.result
    //   const height = 100
    //   const width = 100

    //   img.addEventListener('load', function() {
    //     let canvas = document.createElement("canvas")
    //     canvas.height = height
    //     canvas.width = width
    //     let ctx = canvas.getContext("2d")
    //     ctx.drawImage(img, 0, 0, height, width)
    //     const dataUrl = canvas.toDataURL("image/png")
    //     img.src = dataUrl

    //     self.setState({img: dataUrl})
    //     self.setState({fname: file['name']})
    //     self.setState({[name]: file})
    //     // self.setState({[name]: file})

    //     self.renderImage(img)
    //   }, false)
    // }
  }

  displayContent() {
    let body = <Loader/>

    if (this.state.loaded) {
      body = <UserEdit
        renderImage={this.renderImage()}
        loading={this.state.loading}
        user={this.state.user}
        selectGender={this.selectGender}
        change={this.handleChange}
        handleFileChange={this.handleFileChange}
        submit={this.handleSubmit}
        fname={this.state.fname}
        getDatePickerValue={this.getDatePickerValue}
        selectedGender={this.state.selectedGender}
        phones={this.state.phones}
        handleChangePhone={this.handleChangePhone}
        addPhone={this.addPhone}
        deletePhone={this.deletePhone}
        />
    }

    return body
  }

  render() {
    return (
      <div className="page-user">
        {this.displayContent()}
      </div>
    )
  }
}

export default UserEditContainer
